import { render } from "./Teacherheader.vue?vue&type=template&id=fa171668"
import script from "./Teacherheader.vue?vue&type=script&lang=js"
export * from "./Teacherheader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__